import apiClient from "services/axios";

const API = {
  create: "/api/v1/jwts",
};

export const create = async (body) => {
  const response = await apiClient.post(API.create, body);
  if (response) {
    return response.data;
  }
  return false;
};
